import type { FrontendWidget } from '../../types';
import { ImageWidgetComponent } from './ImageComponent';
import type { ImageWidgetConfig, ImageWidgetResolved } from './types';

export const imageWidget: FrontendWidget<
  ImageWidgetConfig,
  ImageWidgetResolved
> = {
  componentType: 'content-blocks.image',
  displayName: 'Image',
  // Mirrors the Strapi schema defaults — only ever applied to a block an
  // editor *creates* from the picker, never to one loaded from the CMS.
  defaultValues: { alignment: 'center', altText: '', imageShape: 'rounded' },
  ComponentA: ImageWidgetComponent,
  resolveSync: (config) => config,
};
